import CheckboxInput from './CheckboxInput'

export default CheckboxInput



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/CheckboxInput/index.js